import { RecurrenceConfigField } from './RecurrenceConfigField';

interface TaskRecurrenceFieldProps {
  form: any;
  disabled?: boolean;
}

export const TaskRecurrenceField: React.FC<TaskRecurrenceFieldProps> = ({
  form,
  disabled,
}) => {
  return (
    <RecurrenceConfigField
      form={form}
      fieldPath="recurrence"
      label="repeatableTask"
      infoText="repeatableTaskInfo"
      disabled={disabled}
    />
  );
};
